export type StudioAccessSyncStatus = 'idle' | 'loading' | 'ready' | 'error'

export type StudioAccessState = 'pending' | 'granted' | 'denied' | 'error'

/**
 * A cached non-empty studio list is safe to render while access is refreshed.
 * An empty list, however, means "no access" only after a successful server check.
 */
export function resolveStudioAccessState(
  studiosCount: number,
  syncStatus: StudioAccessSyncStatus
): StudioAccessState {
  if (studiosCount > 0) return 'granted'
  if (syncStatus === 'ready') return 'denied'
  if (syncStatus === 'error') return 'error'
  return 'pending'
}
